// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"241":"203108c753d3322b","4009":"a12c974a74b3791c","9658":"9f14c81faf2a951a"}[chunkId] + ".css";
};